import { enforceValid_StoragePermissionDTOPatchGroupPermissions, enforceValid_StoragePermissionDTOPatchUserPermissions } from '.';
import { ApiService } from './api-service';
import { extractMinimalContextWithAppIdAndEnvIdFromLocalId, generateUserCapabilitiesFromPermissions } from './backend-resolver-helper';
import { transformRestOptionsToDTO } from './model/dto-transformers';
import { validateInvokeParams_DTOGetSingleOptionOfContext, validateInvokeParams_DTOSetDefaultOption, validateInvokeParams_OptionDTOCreateOption, validateInvokeParams_OptionDTODeleteOption, validateInvokeParams_OptionDTOGetCustomFieldContextWithDefaultOption, validateInvokeParams_OptionDTOGetOptions, validateInvokeParams_OptionDTOMoveOption, validateInvokeParams_OptionDTOUpdateOption, validateInvokeParams_PermissionEditorDTOGetFieldPermissions, validateInvokeParams_PermissionEditorDTOUserOrGroupPickerQuery, validateInvokeParams_RestGetAllCustomFieldContexts, validateInvokeParams_RestGetAllCustomFields, } from './model/dto-validators';
import { EMPTY_ERROR_OR_PAYLOAD_PAGINATED_REST_CONTEXTS, EMPTY_RestPaginatedValues, returnError400WithEmptyPayload, returnErrorWithEmptyPayload, returnNoErrorWithPayload, StoragePermissionDTOUpdateType, UNKNOWN_GROUP_GROUPNAME_PLACEHOLDER_DTO, UNKNOWN_USER_DISPLAYNAME_PLACEHOLDER_DTO, } from './model/model';
import { CREATE_CUSTOMFIELD_OPTION, DELETE_CUSTOMFIELD_OPTION, SET_CUSTOMFIELD_DEFAULT_OPTION, GET_ALL_CUSTOM_FIELDS, GET_CUSTOMFIELD_ALL_CONTEXTS_PAGINATED, GET_CUSTOMFIELD_CONTEXT_ALL_OPTIONS, GET_CUSTOMFIELD_CONTEXT_WITH_DEFAULT_OPTION, GET_CUSTOMFIELD_EDITOR_CONTEXT, GET_CUSTOMFIELD_PERMISSIONS_PAGINATED_GROUPS, GET_CUSTOMFIELD_PERMISSIONS_PAGINATED_USERS, GET_CUSTOMFIELD_PERMISSIONS_ALL_GROUPIDS_USERIDS, GET_GROUP_PICKER_QUERY, GET_USER_PICKER_QUERY, MOVE_CUSTOMFIELD_OPTION, PATCH_GROUP_PERMISSIONS, PATCH_USER_PERMISSIONS, UPDATE_CUSTOMFIELD_OPTION, GET_SINGLE_CUSTOMFIELD_OPTION, } from './resolver-keys';
import { doesUserHaveGlobalPermissionOnField, enforceUserHasAccessToFieldAndAtLeastOneContext, enforceUserHasAccessToFieldAndContext, generatelLoggedInUserGroupIds_from_DTOUserWithGroups, getContextIdsUserHasPermissionsFor, getFieldIdsUserHasAtLeastContextPermissionsFor, transformRestContextsToDTOsAndEnforceUserPermissions, transformRestFieldDetailsToDTOsWithPermissions, } from './transformer-service';
import { sanitizeUserInput_accountId, sanitizeUserInput_groupId } from './util';
const getCurrentMilliSeconds = () => {
    return new Date().getTime();
};
export class CustomBackendResolver {
    resolver;
    api;
    route;
    storageService;
    licenseService;
    apiService;
    constructor(resolver, api, route, storageService, licenseService) {
        this.resolver = resolver;
        this.api = api;
        this.route = route;
        this.storageService = storageService;
        this.licenseService = licenseService;
        this.apiService = new ApiService(api, route);
        this.resolver.define(GET_ALL_CUSTOM_FIELDS, this.invoke_getAllCustomFields());
        this.resolver.define(GET_CUSTOMFIELD_ALL_CONTEXTS_PAGINATED, this.invoke_getCustomFieldAllContextsPaginated());
        this.resolver.define(GET_CUSTOMFIELD_CONTEXT_ALL_OPTIONS, this.invoke_getCustomFieldContextAllOptions());
        this.resolver.define(GET_CUSTOMFIELD_CONTEXT_WITH_DEFAULT_OPTION, this.invoke_getCustomFieldContextWithDefaultOption());
        this.resolver.define(CREATE_CUSTOMFIELD_OPTION, this.invoke_createCustomfieldOption());
        this.resolver.define(DELETE_CUSTOMFIELD_OPTION, this.invoke_deleteCustomfieldOption());
        this.resolver.define(UPDATE_CUSTOMFIELD_OPTION, this.invoke_updateCustomfieldOption());
        this.resolver.define(MOVE_CUSTOMFIELD_OPTION, this.invoke_moveCustomfieldOption());
        this.resolver.define(SET_CUSTOMFIELD_DEFAULT_OPTION, this.invoke_setCustomfieldDefaultOption());
        this.resolver.define(GET_SINGLE_CUSTOMFIELD_OPTION, this.invoke_getSingleCustomFieldOption());
        this.resolver.define(GET_CUSTOMFIELD_EDITOR_CONTEXT, this.invoke_getCustomfieldEditorContext());
        this.resolver.define(PATCH_GROUP_PERMISSIONS, this.invoke_patchGroupPermissions());
        this.resolver.define(PATCH_USER_PERMISSIONS, this.invoke_patchUserPermissions());
        this.resolver.define(GET_CUSTOMFIELD_PERMISSIONS_PAGINATED_GROUPS, this.invoke_getFieldPermissions_paginatedGroups());
        this.resolver.define(GET_CUSTOMFIELD_PERMISSIONS_PAGINATED_USERS, this.invoke_getFieldPermissions_paginatedUsers());
        this.resolver.define(GET_CUSTOMFIELD_PERMISSIONS_ALL_GROUPIDS_USERIDS, this.invoke_getFieldPermissions_unpaginatedGroupIdsAndUserIdsOnly());
        this.resolver.define(GET_USER_PICKER_QUERY, this.invoke_userPickerQuery());
        this.resolver.define(GET_GROUP_PICKER_QUERY, this.invoke_groupPickerQuery());
    }
    // Only used in frontend forge/bridge mock
    invoke(key, params, context) {
        if (key === GET_ALL_CUSTOM_FIELDS) {
            return this.invoke_getAllCustomFields()({ context: context, payload: params });
        }
        if (key === GET_CUSTOMFIELD_ALL_CONTEXTS_PAGINATED) {
            return this.invoke_getCustomFieldAllContextsPaginated()({ context: context, payload: params });
        }
        if (key === GET_CUSTOMFIELD_CONTEXT_WITH_DEFAULT_OPTION) {
            return this.invoke_getCustomFieldContextWithDefaultOption()({ context: context, payload: params });
        }
        if (key === GET_CUSTOMFIELD_CONTEXT_ALL_OPTIONS) {
            return this.invoke_getCustomFieldContextAllOptions()({ context: context, payload: params });
        }
        if (key === CREATE_CUSTOMFIELD_OPTION) {
            return this.invoke_createCustomfieldOption()({ context: context, payload: params });
        }
        if (key === DELETE_CUSTOMFIELD_OPTION) {
            return this.invoke_deleteCustomfieldOption()({ context: context, payload: params });
        }
        if (key === UPDATE_CUSTOMFIELD_OPTION) {
            return this.invoke_updateCustomfieldOption()({ context: context, payload: params });
        }
        if (key === MOVE_CUSTOMFIELD_OPTION) {
            return this.invoke_moveCustomfieldOption()({ context: context, payload: params });
        }
        if (key === SET_CUSTOMFIELD_DEFAULT_OPTION) {
            return this.invoke_setCustomfieldDefaultOption()({ context: context, payload: params });
        }
        if (key === GET_SINGLE_CUSTOMFIELD_OPTION) {
            return this.invoke_getSingleCustomFieldOption()({ context: context, payload: params });
        }
        if (key === GET_CUSTOMFIELD_EDITOR_CONTEXT) {
            return this.invoke_getCustomfieldEditorContext()({ context: context, payload: params });
        }
        if (key === PATCH_GROUP_PERMISSIONS) {
            return this.invoke_patchGroupPermissions()({ context: context, payload: params });
        }
        if (key === PATCH_USER_PERMISSIONS) {
            return this.invoke_patchUserPermissions()({ context: context, payload: params });
        }
        if (key === GET_CUSTOMFIELD_PERMISSIONS_PAGINATED_GROUPS) {
            return this.invoke_getFieldPermissions_paginatedGroups()({ context: context, payload: params });
        }
        if (key === GET_CUSTOMFIELD_PERMISSIONS_PAGINATED_USERS) {
            return this.invoke_getFieldPermissions_paginatedUsers()({ context: context, payload: params });
        }
        if (key === GET_CUSTOMFIELD_PERMISSIONS_ALL_GROUPIDS_USERIDS) {
            return this.invoke_getFieldPermissions_unpaginatedGroupIdsAndUserIdsOnly()({ context: context, payload: params });
        }
        if (key === GET_USER_PICKER_QUERY) {
            return this.invoke_userPickerQuery()({ context: context, payload: params });
        }
        if (key === GET_GROUP_PICKER_QUERY) {
            return this.invoke_groupPickerQuery()({ context: context, payload: params });
        }
    }
    //
    // PRIVATE
    //
    async _getLoggedInUserAndUserOrGroupPermissions() {
        //
        // STEP 1: Is Admin Check
        //
        const enforceUserIsAdmin = await this.apiService.rest_api_3_permissions_check___isUserAdmin___asUser();
        //
        // STEP 2: Get Permissions
        //
        const userAndGroupsErrorsOrPayload = await this.apiService.rest_api_3_myself___getLoggedInUserWithGroups___asUser();
        if (userAndGroupsErrorsOrPayload.hasError) {
            return returnErrorWithEmptyPayload(userAndGroupsErrorsOrPayload);
        }
        const loggedInUserAccountId = userAndGroupsErrorsOrPayload.payload.accountId;
        const loggedInUserGroupIds = generatelLoggedInUserGroupIds_from_DTOUserWithGroups(userAndGroupsErrorsOrPayload.payload);
        const permissions = await this.storageService.getUserAndGroupPermissions(loggedInUserAccountId, loggedInUserGroupIds);
        // console.log('PERMS', JSON.stringify(permissions, null, 2));
        return returnNoErrorWithPayload({
            isAdmin: enforceUserIsAdmin.hasError === false,
            userWithGroups: userAndGroupsErrorsOrPayload.payload,
            userOrGroupPermissions: permissions,
        });
    }
    // invoke = GET_ALL_CUSTOM_FIELDS
    async _getAllCustomFields(params) {
        //
        // STEP 1: Get Permissions
        //
        const userOrGroupPermissions = await this._getLoggedInUserAndUserOrGroupPermissions();
        if (userOrGroupPermissions.hasError) {
            return returnErrorWithEmptyPayload(userOrGroupPermissions);
        }
        //
        // STEP 2: Get CustomFields in Admin View (without permission check => we need all fields because search fields does not return fields!)
        //
        let errorAndPayloadCustomFields = EMPTY_RestPaginatedValues;
        if (userOrGroupPermissions.payload.isAdmin) {
            //
            // ADMIN VIEW (all fields)
            //
            errorAndPayloadCustomFields = await this.apiService.rest_api_3_field___getAllCustomFields__forAdmin___asApp(params);
            if (errorAndPayloadCustomFields.hasError) {
                return returnErrorWithEmptyPayload(errorAndPayloadCustomFields);
            }
        }
        else {
            //
            // USER VIEW (only with permissions!)
            //
            const fieldIdsUserHasPermissionsFor = getFieldIdsUserHasAtLeastContextPermissionsFor(userOrGroupPermissions.payload.userOrGroupPermissions);
            if (fieldIdsUserHasPermissionsFor.length === 0) {
                return returnNoErrorWithPayload({
                    userCapabilities: generateUserCapabilitiesFromPermissions(userOrGroupPermissions.payload),
                    fields: {
                        maxResults: 10,
                        startAt: 0,
                        total: 0,
                        isLast: true,
                        processingTimeInMs: 0,
                        values: [],
                    },
                });
            }
            else {
                errorAndPayloadCustomFields = await this.apiService.rest_api_3_field___getAllCustomFields__forUserWithPermissions___asApp(fieldIdsUserHasPermissionsFor, params);
                if (errorAndPayloadCustomFields.hasError) {
                    return returnErrorWithEmptyPayload(errorAndPayloadCustomFields);
                }
            }
        }
        //
        // Step 3: Transform to DTOs and filter our incompatible types
        //
        const dtoFieldsWithPermissions = transformRestFieldDetailsToDTOsWithPermissions(errorAndPayloadCustomFields.payload.values, userOrGroupPermissions.payload.userOrGroupPermissions, userOrGroupPermissions.payload.isAdmin);
        //
        // Step 6: Return
        //
        return returnNoErrorWithPayload({
            userCapabilities: generateUserCapabilitiesFromPermissions(userOrGroupPermissions.payload),
            fields: {
                maxResults: errorAndPayloadCustomFields.payload.maxResults,
                startAt: errorAndPayloadCustomFields.payload.startAt,
                total: errorAndPayloadCustomFields.payload.total,
                isLast: errorAndPayloadCustomFields.payload.isLast,
                processingTimeInMs: 0,
                values: dtoFieldsWithPermissions,
            },
        });
    }
    //
    // PUBLIC
    //
    invoke_getAllCustomFields() {
        return async (ctxpayload) => {
            const before = getCurrentMilliSeconds();
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const params = ctxpayload.payload;
            const validatedInvokeParams = await validateInvokeParams_RestGetAllCustomFields(params);
            if (validatedInvokeParams.hasError) {
                return returnErrorWithEmptyPayload(validatedInvokeParams);
            }
            //
            // BUSINESS LOGIC
            //
            const result = await this._getAllCustomFields(params);
            if (!result.hasError) {
                result.payload.fields.processingTimeInMs = getCurrentMilliSeconds() - before;
            }
            return result;
        };
    }
    invoke_getCustomFieldAllContextsPaginated() {
        return async (ctxpayload) => {
            const before = getCurrentMilliSeconds();
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const params = ctxpayload.payload;
            const validatedInvokeParams = await validateInvokeParams_RestGetAllCustomFieldContexts(params);
            if (validatedInvokeParams.hasError) {
                return returnErrorWithEmptyPayload(validatedInvokeParams);
            }
            //
            // AUTH GUARDS
            //
            const userPermissions = await this._getLoggedInUserAndUserOrGroupPermissions();
            if (userPermissions.hasError) {
                return returnErrorWithEmptyPayload(userPermissions);
            }
            const userCapabilities = generateUserCapabilitiesFromPermissions(userPermissions.payload);
            const userHasAccess = enforceUserHasAccessToFieldAndAtLeastOneContext(userPermissions.payload, params.fieldId, 'USRHSACC_792392');
            if (userHasAccess.hasError) {
                return returnErrorWithEmptyPayload(userHasAccess);
            }
            //
            // BUSINESS LOGIC (IMPLICIT validType and isUnlocked)
            //
            const fieldOrError = await this.apiService.rest_api_3_field_search___getSingleCustomField___enforceValidTypeAndUnlocked___asApp(params.fieldId);
            if (fieldOrError.hasError) {
                return returnErrorWithEmptyPayload(fieldOrError);
            }
            if (userPermissions.payload.isAdmin || doesUserHaveGlobalPermissionOnField(userPermissions.payload, params.fieldId)) {
                //
                // ADMIN VIEW + USER GLOBAL PERMISSION VIEW
                //
                let errorAndPayloadContexts = EMPTY_ERROR_OR_PAYLOAD_PAGINATED_REST_CONTEXTS;
                if (params.currentFilter && params.currentFilter !== '') {
                    //
                    // VARIANT 1 WITH FILTER - get onyl first 300 contexts, pagination done in memory
                    //
                    errorAndPayloadContexts = await this.apiService.rest_api_3_field_FIELDID_context___getAllCustomFieldContexts___forAdminOrGlobalPermissionWithFilterPaginated__asApp(params);
                    if (errorAndPayloadContexts.hasError) {
                        return returnErrorWithEmptyPayload(errorAndPayloadContexts);
                    }
                }
                else {
                    //
                    // VARIANT 2 WITHOUT FILTER - get all contexts, pagination done in REST API
                    //
                    errorAndPayloadContexts = await this.apiService.rest_api_3_field_FIELDID_context___getAllCustomFieldContexts___forAdminOrGlobalPermissionWithoutFilterPaginated___asApp(params);
                    if (errorAndPayloadContexts.hasError) {
                        return returnErrorWithEmptyPayload(errorAndPayloadContexts);
                    }
                }
                const contexts = transformRestContextsToDTOsAndEnforceUserPermissions(params.fieldId, errorAndPayloadContexts.payload.values, userPermissions.payload);
                return returnNoErrorWithPayload({
                    userCapabilities: userCapabilities,
                    field: fieldOrError.payload,
                    contexts: {
                        maxResults: errorAndPayloadContexts.payload.maxResults,
                        startAt: errorAndPayloadContexts.payload.startAt,
                        total: errorAndPayloadContexts.payload.total,
                        isLast: errorAndPayloadContexts.payload.isLast,
                        processingTimeInMs: getCurrentMilliSeconds() - before,
                        values: contexts,
                    },
                });
            }
            else {
                //
                // USER VIEW (only with permissions!)
                //
                const contextIdsUserHasPermissionsFor = getContextIdsUserHasPermissionsFor(userPermissions.payload.userOrGroupPermissions, fieldOrError.payload.fieldId);
                const errorAndPayloadContexts = await this.apiService.rest_api_3_field_FIELDID_context___getAllCustomFieldContexts__forUserWithPermissions___asApp(contextIdsUserHasPermissionsFor, params);
                if (errorAndPayloadContexts.hasError) {
                    return returnErrorWithEmptyPayload(errorAndPayloadContexts);
                }
                const contexts = transformRestContextsToDTOsAndEnforceUserPermissions(params.fieldId, errorAndPayloadContexts.payload.values, userPermissions.payload);
                return returnNoErrorWithPayload({
                    userCapabilities: userCapabilities,
                    field: fieldOrError.payload,
                    contexts: {
                        maxResults: errorAndPayloadContexts.payload.maxResults,
                        startAt: errorAndPayloadContexts.payload.startAt,
                        total: errorAndPayloadContexts.payload.total,
                        isLast: errorAndPayloadContexts.payload.isLast,
                        processingTimeInMs: getCurrentMilliSeconds() - before,
                        values: contexts,
                    },
                });
            }
        };
    }
    invoke_getCustomFieldContextWithDefaultOption() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const validatedInvokeParams = await validateInvokeParams_OptionDTOGetCustomFieldContextWithDefaultOption(ctxpayload.payload);
            if (validatedInvokeParams.hasError) {
                return returnErrorWithEmptyPayload(validatedInvokeParams);
            }
            //
            // AUTH GUARDS
            //
            const userPermissions = await this._getLoggedInUserAndUserOrGroupPermissions();
            if (userPermissions.hasError) {
                return returnErrorWithEmptyPayload(userPermissions);
            }
            const userHasAccess = enforceUserHasAccessToFieldAndContext(userPermissions.payload, validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, 'USRFLDACC_876878');
            if (userHasAccess.hasError) {
                return returnErrorWithEmptyPayload(userHasAccess);
            }
            //
            // BUSINESS LOGIC (IMPLICIT validType and isUnlocked)
            //
            const fieldOrError = await this.apiService.rest_api_3_field_search___getSingleCustomField___enforceValidTypeAndUnlocked___asApp(ctxpayload.payload.fieldId);
            if (fieldOrError.hasError) {
                return returnErrorWithEmptyPayload(fieldOrError);
            }
            const contextOrError = await this.apiService.rest_api_3_field_FIELDID_context___getSingleCustomFieldContext___asApp({
                fieldId: ctxpayload.payload.fieldId,
                contextId: ctxpayload.payload.contextId,
            });
            if (contextOrError.hasError) {
                return returnErrorWithEmptyPayload(contextOrError);
            }
            const defaultOptionsOrError = await this.apiService.rest_api_3_field_context_defaultValue___getDefaultOptionsForContext___asApp(validatedInvokeParams.payload.fieldId, `${validatedInvokeParams.payload.contextId}`, fieldOrError.payload.fieldType);
            if (defaultOptionsOrError.hasError) {
                return returnErrorWithEmptyPayload(defaultOptionsOrError);
            }
            return returnNoErrorWithPayload({
                field: fieldOrError.payload,
                context: contextOrError.payload,
                userCapabilities: generateUserCapabilitiesFromPermissions(userPermissions.payload),
                defaultOption: defaultOptionsOrError.payload,
            });
        };
    }
    invoke_getCustomFieldContextAllOptions() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const validatedInvokeParams = await validateInvokeParams_OptionDTOGetOptions(ctxpayload.payload);
            if (validatedInvokeParams.hasError) {
                return returnErrorWithEmptyPayload(validatedInvokeParams);
            }
            //
            // AUTH GUARDS
            //
            const userPermissions = await this._getLoggedInUserAndUserOrGroupPermissions();
            if (userPermissions.hasError) {
                return returnErrorWithEmptyPayload(userPermissions);
            }
            const userHasAccess = enforceUserHasAccessToFieldAndContext(userPermissions.payload, validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, 'USRFLDCTXACC_7304985');
            if (userHasAccess.hasError) {
                return returnErrorWithEmptyPayload(userHasAccess);
            }
            const enforceIsUnlockedAndValidFieldTypeOrError = await this.apiService.rest_api_3_field_search___getSingleCustomField___enforceValidTypeAndUnlocked___asApp(validatedInvokeParams.payload.fieldId);
            if (enforceIsUnlockedAndValidFieldTypeOrError.hasError) {
                return returnErrorWithEmptyPayload(enforceIsUnlockedAndValidFieldTypeOrError);
            }
            //
            // BUSINESS LOGIC
            //
            const allOptionsPaginated = await this.apiService.rest_api_3_field_FIELDID_context_CONTEXTID_option___getAllOptionsOfContext___asApp(validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, validatedInvokeParams.payload.parentOptionId);
            if (allOptionsPaginated.hasError) {
                return returnErrorWithEmptyPayload(allOptionsPaginated);
            }
            else {
                return returnNoErrorWithPayload(transformRestOptionsToDTO(allOptionsPaginated.payload));
            }
        };
    }
    invoke_updateCustomfieldOption() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const validatedInvokeParams = await validateInvokeParams_OptionDTOUpdateOption(ctxpayload.payload);
            if (validatedInvokeParams.hasError) {
                return returnErrorWithEmptyPayload(validatedInvokeParams);
            }
            //
            // AUTH GUARDS
            //
            const userPermissions = await this._getLoggedInUserAndUserOrGroupPermissions();
            if (userPermissions.hasError) {
                return returnErrorWithEmptyPayload(userPermissions);
            }
            const userHasAccess = enforceUserHasAccessToFieldAndContext(userPermissions.payload, validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, 'USRFLDCTXACC_2928479');
            if (userHasAccess.hasError) {
                return returnErrorWithEmptyPayload(userHasAccess);
            }
            const enforceIsUnlockedAndValidFieldTypeOrError = await this.apiService.rest_api_3_field_search___getSingleCustomField___enforceValidTypeAndUnlocked___asApp(validatedInvokeParams.payload.fieldId);
            if (enforceIsUnlockedAndValidFieldTypeOrError.hasError) {
                return returnErrorWithEmptyPayload(enforceIsUnlockedAndValidFieldTypeOrError);
            }
            //
            // BUSINESS LOGIC
            //
            const result = await this.apiService.rest_api_3_field_FIELDID_context_CONTEXTID_option___updateOption___asApp(validatedInvokeParams.payload);
            if (result.hasError) {
                return returnErrorWithEmptyPayload(result);
            }
            else {
                return result;
            }
        };
    }
    invoke_createCustomfieldOption() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const validatedInvokeParams = await validateInvokeParams_OptionDTOCreateOption(ctxpayload.payload);
            if (validatedInvokeParams.hasError) {
                return returnErrorWithEmptyPayload(validatedInvokeParams);
            }
            //
            // AUTH GUARDS
            //
            const userPermissions = await this._getLoggedInUserAndUserOrGroupPermissions();
            if (userPermissions.hasError) {
                return returnErrorWithEmptyPayload(userPermissions);
            }
            const userHasAccess = enforceUserHasAccessToFieldAndContext(userPermissions.payload, validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, 'USRFLDCTXACC_0365482');
            if (userHasAccess.hasError) {
                return returnErrorWithEmptyPayload(userHasAccess);
            }
            const enforceIsUnlockedAndValidFieldTypeOrError = await this.apiService.rest_api_3_field_search___getSingleCustomField___enforceValidTypeAndUnlocked___asApp(validatedInvokeParams.payload.fieldId);
            if (enforceIsUnlockedAndValidFieldTypeOrError.hasError) {
                return returnErrorWithEmptyPayload(enforceIsUnlockedAndValidFieldTypeOrError);
            }
            //
            // BUSINESS LOGIC
            //
            const result = await this.apiService.rest_api_3_field_FIELDID_context_CONTEXTID_option___createOption___asApp(validatedInvokeParams.payload);
            if (result.hasError) {
                return returnErrorWithEmptyPayload(result);
            }
            else {
                return result;
            }
        };
    }
    invoke_moveCustomfieldOption() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const validatedInvokeParams = await validateInvokeParams_OptionDTOMoveOption(ctxpayload.payload);
            if (validatedInvokeParams.hasError) {
                return returnErrorWithEmptyPayload(validatedInvokeParams);
            }
            //
            // AUTH GUARDS
            //
            const userPermissions = await this._getLoggedInUserAndUserOrGroupPermissions();
            if (userPermissions.hasError) {
                return returnErrorWithEmptyPayload(userPermissions);
            }
            const userHasAccess = enforceUserHasAccessToFieldAndContext(userPermissions.payload, validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, 'USRFLDCTXACC_4567332');
            if (userHasAccess.hasError) {
                return returnErrorWithEmptyPayload(userHasAccess);
            }
            const enforceIsUnlockedAndValidFieldTypeOrError = await this.apiService.rest_api_3_field_search___getSingleCustomField___enforceValidTypeAndUnlocked___asApp(validatedInvokeParams.payload.fieldId);
            if (enforceIsUnlockedAndValidFieldTypeOrError.hasError) {
                return returnErrorWithEmptyPayload(enforceIsUnlockedAndValidFieldTypeOrError);
            }
            //
            // BUSINESS LOGIC
            //
            const result = await this.apiService.rest_api_3_field_FIELDID_context_CONTEXTID_option_move___moveOption___asApp(validatedInvokeParams.payload);
            if (result.hasError) {
                return returnErrorWithEmptyPayload(result);
            }
            else {
                return result;
            }
        };
    }
    invoke_deleteCustomfieldOption() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const validatedInvokeParams = await validateInvokeParams_OptionDTODeleteOption(ctxpayload.payload);
            if (validatedInvokeParams.hasError) {
                return returnErrorWithEmptyPayload(validatedInvokeParams);
            }
            //
            // AUTH GUARDS
            //
            const userPermissions = await this._getLoggedInUserAndUserOrGroupPermissions();
            if (userPermissions.hasError) {
                return returnErrorWithEmptyPayload(userPermissions);
            }
            const userHasAccess = enforceUserHasAccessToFieldAndContext(userPermissions.payload, validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, 'USRFLDCTXACC_4546227');
            if (userHasAccess.hasError) {
                return returnErrorWithEmptyPayload(userHasAccess);
            }
            const enforceIsUnlockedAndValidFieldTypeOrError = await this.apiService.rest_api_3_field_search___getSingleCustomField___enforceValidTypeAndUnlocked___asApp(validatedInvokeParams.payload.fieldId);
            if (enforceIsUnlockedAndValidFieldTypeOrError.hasError) {
                return returnErrorWithEmptyPayload(enforceIsUnlockedAndValidFieldTypeOrError);
            }
            //
            // BUSINESS LOGIC
            //
            if (!validatedInvokeParams.payload.parentOptionId) {
                // Only on cascading types
                const hasChildOptions = await this.apiService.rest_api_3_field_FIELDID_context_CONTEXTID_option___hasOptionChildOptions___asApp(validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, validatedInvokeParams.payload.delete.id);
                if (hasChildOptions.hasError) {
                    return returnError400WithEmptyPayload(hasChildOptions.errorMessage, 'CHLDERR_2334671');
                }
                else if (hasChildOptions.payload === true) {
                    return returnError400WithEmptyPayload('Cannot delete parent option that has child options', 'CHLDERR_2334994');
                }
            }
            const result = await this.apiService.rest_api_3_field_FIELDID_context_CONTEXTID_option_OPTIONID___deleteOption___asApp(validatedInvokeParams.payload);
            if (result.hasError) {
                return returnErrorWithEmptyPayload(result);
            }
            else {
                return result;
            }
        };
    }
    /*
     * TYPE:     ADMIN AND USER ENDPOINT
     * SECURITY: NO PERMISSION CHECK NEEDED - IMPLICIT
     */
    invoke_getCustomfieldEditorContext() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            // NOTE: Special Case => We return the license active data as boolean for this method!
            //
            // PARAM GUARDS
            //
            // not needed, since we only get invokeParams.context which is safely provided by jira
            //
            // BUSINESS LOGIC
            //
            const minimalContext = extractMinimalContextWithAppIdAndEnvIdFromLocalId(ctxpayload);
            const myselfOrError = await this.apiService.rest_api_3_myself___getLoggedInUserWithGroups___asUser();
            const errorAndPayload = {
                hasError: myselfOrError.hasError,
                statusCode: myselfOrError.statusCode,
                errorMessage: myselfOrError.errorMessage,
                payload: {
                    entrypoint: ctxpayload.context.moduleKey,
                    myself: myselfOrError.payload,
                    isLicenseActive: !licenseCheck.hasError,
                    context: minimalContext,
                },
            };
            return errorAndPayload;
        };
    }
    invoke_setCustomfieldDefaultOption() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const validatedInvokeParams = await validateInvokeParams_DTOSetDefaultOption(ctxpayload.payload);
            if (validatedInvokeParams.hasError) {
                return returnErrorWithEmptyPayload(validatedInvokeParams);
            }
            //
            // AUTH GUARDS
            //
            const userPermissions = await this._getLoggedInUserAndUserOrGroupPermissions();
            if (userPermissions.hasError) {
                return returnErrorWithEmptyPayload(userPermissions);
            }
            const userHasAccess = enforceUserHasAccessToFieldAndContext(userPermissions.payload, validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, 'USRFLDCTXACC_8932403');
            if (userHasAccess.hasError) {
                return returnErrorWithEmptyPayload(userHasAccess);
            }
            const enforceIsUnlockedAndValidFieldTypeOrError = await this.apiService.rest_api_3_field_search___getSingleCustomField___enforceValidTypeAndUnlocked___asApp(validatedInvokeParams.payload.fieldId);
            if (enforceIsUnlockedAndValidFieldTypeOrError.hasError) {
                return returnErrorWithEmptyPayload(enforceIsUnlockedAndValidFieldTypeOrError);
            }
            //
            // BUSINESS LOGIC
            //
            const result = await this.apiService.rest_api_3_field_context_defaultValue___setDefaultOptionsForContext___asApp(validatedInvokeParams.payload, enforceIsUnlockedAndValidFieldTypeOrError.payload.fieldType);
            if (result.hasError) {
                return returnErrorWithEmptyPayload(result);
            }
            else {
                return result;
            }
        };
    }
    invoke_getSingleCustomFieldOption() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const validatedInvokeParams = await validateInvokeParams_DTOGetSingleOptionOfContext(ctxpayload.payload);
            if (validatedInvokeParams.hasError) {
                return returnErrorWithEmptyPayload(validatedInvokeParams);
            }
            //
            // AUTH GUARDS
            //
            const userPermissions = await this._getLoggedInUserAndUserOrGroupPermissions();
            if (userPermissions.hasError) {
                return returnErrorWithEmptyPayload(userPermissions);
            }
            const userHasAccess = enforceUserHasAccessToFieldAndContext(userPermissions.payload, validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, 'USRFLDCTXACC_92323412');
            if (userHasAccess.hasError) {
                return returnErrorWithEmptyPayload(userHasAccess);
            }
            const enforceIsUnlockedAndValidFieldTypeOrError = await this.apiService.rest_api_3_field_search___getSingleCustomField___enforceValidTypeAndUnlocked___asApp(validatedInvokeParams.payload.fieldId);
            if (enforceIsUnlockedAndValidFieldTypeOrError.hasError) {
                return returnErrorWithEmptyPayload(enforceIsUnlockedAndValidFieldTypeOrError);
            }
            //
            // BUSINESS LOGIC
            //
            const result = await this.apiService.rest_api_3_field_FIELDID_context_CONTEXTID_option___getSingleOptionOfContext___asApp(validatedInvokeParams.payload.fieldId, validatedInvokeParams.payload.contextId, validatedInvokeParams.payload.optionId);
            if (result.hasError) {
                return returnErrorWithEmptyPayload(result);
            }
            else {
                return result;
            }
        };
    }
    //
    //
    //
    // ADMIN OPERATIONS
    //
    //
    //
    /*
     * TYPE:     ADMIN ENDPOINT
     * SECURITY: VIA PERMISSION CHECK FOR ADMIN ROLE
     */
    invoke_patchGroupPermissions() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const errorOrPayloadDTO = await enforceValid_StoragePermissionDTOPatchGroupPermissions(ctxpayload.payload);
            if (errorOrPayloadDTO.hasError) {
                return errorOrPayloadDTO;
            }
            //
            // AUTH GUARDS
            //
            const enforceUserIsAdmin = await this.apiService.rest_api_3_permissions_check___isUserAdmin___asUser();
            if (enforceUserIsAdmin.hasError) {
                return returnErrorWithEmptyPayload(enforceUserIsAdmin);
            }
            if (ctxpayload.payload.type === StoragePermissionDTOUpdateType.ADD) {
                // NOTE: We only check for group exists on add. We allow deletion of non existing groups!
                const sanitizedGroupId = sanitizeUserInput_groupId(ctxpayload.payload.groupId);
                const foundGroups = await this.apiService.rest_api_2_group_bulk___findGroupsByGroupIds___asApp({ groupIds: [sanitizedGroupId], maxResults: 1, startAt: 0, currentFilter: null });
                if (foundGroups.hasError) {
                    return returnErrorWithEmptyPayload(foundGroups);
                }
                if (foundGroups.payload.values.length === 0 || (foundGroups.payload.values[0] && foundGroups.payload.values[0].groupName === UNKNOWN_GROUP_GROUPNAME_PLACEHOLDER_DTO)) {
                    return returnError400WithEmptyPayload('No group found for groupId: ' + sanitizedGroupId, 'NGRPFND_9802341');
                }
            }
            //
            // BUSINESS LOGC
            //
            return await this.storageService.patchGroupPermissions(ctxpayload.payload);
        };
    }
    /*
     * TYPE:     ADMIN ENDPOINT
     * SECURITY: VIA PERMISSION CHECK FOR ADMIN ROLE
     */
    invoke_patchUserPermissions() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const errorOrPayloadDTO = await enforceValid_StoragePermissionDTOPatchUserPermissions(ctxpayload.payload);
            if (errorOrPayloadDTO.hasError) {
                return errorOrPayloadDTO;
            }
            //
            // AUTH GUARDS
            //
            const enforceUserIsAdmin = await this.apiService.rest_api_3_permissions_check___isUserAdmin___asUser();
            if (enforceUserIsAdmin.hasError) {
                return returnErrorWithEmptyPayload(enforceUserIsAdmin);
            }
            if (ctxpayload.payload.type === StoragePermissionDTOUpdateType.ADD) {
                const sanitizedAccountId = sanitizeUserInput_accountId(ctxpayload.payload.userAccountId);
                const foundUsers = await this.apiService.rest_api_3_user_bulk___findUsersByAccountIds___asApp({
                    accountIds: [sanitizedAccountId],
                    startAt: 0,
                    maxResults: 1,
                    currentFilter: null,
                });
                if (foundUsers.hasError) {
                    return returnErrorWithEmptyPayload(foundUsers);
                }
                if (!foundUsers.payload ||
                    foundUsers.payload.values.length === 0 ||
                    (foundUsers.payload.values[0] && foundUsers.payload.values[0].accountId !== sanitizedAccountId) ||
                    foundUsers.payload.values[0].displayName === UNKNOWN_USER_DISPLAYNAME_PLACEHOLDER_DTO) {
                    return returnError400WithEmptyPayload('No user found for accountId: ' + sanitizedAccountId, 'NUSRFND_98793221');
                }
            }
            //
            // BUSINESS LOGIC
            //
            return await this.storageService.patchUserPermissions(ctxpayload.payload);
        };
    }
    /*
     * TYPE:     ADMIN ENDPOINT
     * SECURITY: VIA PERMISSION CHECK FOR ADMIN ROLE
     */
    invoke_getFieldPermissions_paginatedUsers() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const errorOrPayloadDTO = await validateInvokeParams_PermissionEditorDTOGetFieldPermissions(ctxpayload.payload);
            if (errorOrPayloadDTO.hasError) {
                return returnError400WithEmptyPayload(errorOrPayloadDTO.errorMessage, 'PRMERR_9782124');
            }
            //
            // AUTH GUARDS
            //
            const enforceUserIsAdmin = await this.apiService.rest_api_3_permissions_check___isUserAdmin___asUser();
            if (enforceUserIsAdmin.hasError) {
                return returnErrorWithEmptyPayload(enforceUserIsAdmin);
            }
            //
            // BUSINESS LOGIC
            //
            const perms = await this.storageService.getFieldPermissions(ctxpayload.payload.fieldId, ctxpayload.payload.contextId);
            const usersFoundErrorAndPayload = await this.apiService.rest_api_3_user_bulk___findUsersByAccountIds___asApp({
                accountIds: perms.userIds,
                startAt: errorOrPayloadDTO.payload.startAt,
                maxResults: errorOrPayloadDTO.payload.maxResults,
                currentFilter: null,
            });
            if (usersFoundErrorAndPayload.hasError) {
                return returnErrorWithEmptyPayload(usersFoundErrorAndPayload);
            }
            return returnNoErrorWithPayload(usersFoundErrorAndPayload.payload);
        };
    }
    /*
     * TYPE:     ADMIN ENDPOINT
     * SECURITY: VIA PERMISSION CHECK FOR ADMIN ROLE
     */
    invoke_getFieldPermissions_unpaginatedGroupIdsAndUserIdsOnly() {
        // WE NEED THIS IN FRONTEND TO KNOW IF USERS OR GROUPS ARE ALREADY ASSIGNED TO PERMISSION
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const errorOrPayloadDTO = await validateInvokeParams_PermissionEditorDTOGetFieldPermissions(ctxpayload.payload);
            if (errorOrPayloadDTO.hasError) {
                return returnError400WithEmptyPayload(errorOrPayloadDTO.errorMessage, 'PRMERR_9782124');
            }
            //
            // AUTH GUARDS
            //
            const enforceUserIsAdmin = await this.apiService.rest_api_3_permissions_check___isUserAdmin___asUser();
            if (enforceUserIsAdmin.hasError) {
                return returnErrorWithEmptyPayload(enforceUserIsAdmin);
            }
            //
            // BUSINESS LOGIC
            //
            const perms = await this.storageService.getFieldPermissions(ctxpayload.payload.fieldId, ctxpayload.payload.contextId);
            return returnNoErrorWithPayload({
                groupIds: perms.groupIds,
                userIds: perms.userIds,
            });
        };
    }
    /*
     * TYPE:     ADMIN ENDPOINT
     * SECURITY: VIA PERMISSION CHECK FOR ADMIN ROLE
     */
    invoke_getFieldPermissions_paginatedGroups() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const errorOrPayloadDTO = await validateInvokeParams_PermissionEditorDTOGetFieldPermissions(ctxpayload.payload);
            if (errorOrPayloadDTO.hasError) {
                return returnError400WithEmptyPayload(errorOrPayloadDTO.errorMessage, 'PRMERR_9782124');
            }
            //
            // AUTH GUARDS
            //
            const enforceUserIsAdmin = await this.apiService.rest_api_3_permissions_check___isUserAdmin___asUser();
            if (enforceUserIsAdmin.hasError) {
                return returnErrorWithEmptyPayload(enforceUserIsAdmin);
            }
            //
            // BUSINESS LOGIC
            //
            const perms = await this.storageService.getFieldPermissions(ctxpayload.payload.fieldId, ctxpayload.payload.contextId);
            const groupsFoundErrorAndPayload = await this.apiService.rest_api_2_group_bulk___findGroupsByGroupIds___asApp({
                groupIds: perms.groupIds,
                startAt: errorOrPayloadDTO.payload.startAt,
                maxResults: errorOrPayloadDTO.payload.maxResults,
                currentFilter: null,
            });
            if (groupsFoundErrorAndPayload.hasError) {
                return returnErrorWithEmptyPayload(groupsFoundErrorAndPayload);
            }
            return returnNoErrorWithPayload(groupsFoundErrorAndPayload.payload);
        };
    }
    /*
     * TYPE:     ADMIN ENDPOINT
     * SECURITY: IMPLICIT-SAFE
     *            - because api.asUser() implicitly needs admin permissions to query for users via REST API
     *            - non-admin users get errors using this endpoint
     */
    invoke_userPickerQuery() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const errorOrPayloadDTO = await validateInvokeParams_PermissionEditorDTOUserOrGroupPickerQuery(ctxpayload.payload);
            if (errorOrPayloadDTO.hasError) {
                return returnError400WithEmptyPayload(errorOrPayloadDTO.errorMessage, 'PRMERR_21329458');
            }
            //
            // AUTH GUARDS
            //
            const enforceUserIsAdmin = await this.apiService.rest_api_3_permissions_check___isUserAdmin___asUser();
            if (enforceUserIsAdmin.hasError) {
                return returnErrorWithEmptyPayload(enforceUserIsAdmin);
            }
            //
            // BUSINESS LOGIC
            //
            const errorAndPayload = await this.apiService.rest_api_3_user_picker___findUsersForPicker___asUser(errorOrPayloadDTO.payload.query);
            if (errorAndPayload.hasError) {
                return returnError400WithEmptyPayload(errorAndPayload.errorMessage, 'USRPCKR_0987313');
            }
            else {
                return errorAndPayload;
            }
        };
    }
    /*
     * TYPE:     ADMIN ENDPOINT
     * SECURITY: IMPLICIT-SAFE
     *            - because api.asUser() implicitly needs admin permissions to query for users via REST API
     *            - non-admin users get errors using this endpoint
     */
    invoke_groupPickerQuery() {
        return async (ctxpayload) => {
            //
            // LICENSE GUARD
            //
            const licenseCheck = this.licenseService.enforceValidLicense(ctxpayload.context);
            if (licenseCheck.hasError) {
                return licenseCheck;
            }
            //
            // PARAM GUARDS
            //
            const errorOrPayloadDTO = await validateInvokeParams_PermissionEditorDTOUserOrGroupPickerQuery(ctxpayload.payload);
            if (errorOrPayloadDTO.hasError) {
                return returnError400WithEmptyPayload(errorOrPayloadDTO.errorMessage, 'GRPPCKR_04564873');
            }
            //
            // AUTH GUARDS
            //
            const enforceUserIsAdmin = await this.apiService.rest_api_3_permissions_check___isUserAdmin___asUser();
            if (enforceUserIsAdmin.hasError) {
                return returnErrorWithEmptyPayload(enforceUserIsAdmin);
            }
            //
            // BUSINESS LOGIC
            //
            const errorAndPayload = await this.apiService.rest_api_3_groups_picker___findGroupsForPicker___asUser(errorOrPayloadDTO.payload.query);
            if (errorAndPayload.hasError) {
                return returnError400WithEmptyPayload(errorAndPayload.errorMessage, 'GRPPCKR_23432457');
            }
            else {
                return errorAndPayload;
            }
        };
    }
}
